
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockAdjustOutGrid extends Serenity.EntityGrid<IcStockAdjustOutRow, any> {
        protected getColumnsKey() { return IcStockAdjustOutColumns.columnsKey; }
        protected getDialogType() { return IcStockAdjustOutDialog; }
        protected getIdProperty() { return IcStockAdjustOutRow.idProperty; }
        protected getInsertPermission() { return IcStockAdjustOutRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockAdjustOutRow.localTextPrefix; }
        protected getService() { return IcStockAdjustOutService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();

            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcStockAdjustOutService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            

            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;

                    },
                }
            );

            buttons.push({
                title: "Import From Excel",
                hint: "Import AdjustStock from Excel template",
                cssClass: "upload-AdjustStock-template-button",
                icon: "fa-cloud-upload-alt",
                separator: true,
                onClick: () => {
                    const dialog = new Common.ImportAdjustStockDialog()
                    this.initDialog(dialog)
                    dialog.importState = () => {
                        Q.notifySuccess("Import from Excel successfully.")
                        this.refresh()
                    }
    
                    dialog.dialogOpen()
                }
            })

            buttons.push({
                title: "Download Template",
                hint: "Download Excel template for AdjustStock import",
                cssClass: "download-AdjustStock-template-button",
                icon: "fa-download",
                separator: true,
                onClick: () => {
                    window.location.href = Q.resolveUrl("~/Services/Csi/DownloadImportAdjustStockTemplate");
                }
            })


            return buttons;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        } 
        protected getColumns() {
            var columns = super.getColumns();
    
            columns.splice(1, 0, {
                id: 'Print CountApprove',
                field: null,
                name: '',
                cssClass: 'align-center',
                format: ctx => {
                    return '<a class="inline-action print-countapprove" title="countapprove">' +
                    '<i class="fa fa-file-pdf-o text-red"></i></a>';
                },
                width: 30,
                minWidth: 30,
                maxWidth: 30
            });
    
            return columns;
        }
    
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
    
            // if (e.isDefaultPrevented())
            //     return;
    
            var item = this.itemAt(row);
            var target = $(e.target);

            
            if (target.parent().hasClass('inline-action'))
                target = target.parent();
    
            if (target.hasClass('inline-action')) {
                e.preventDefault();
    
                if (target.hasClass('print-countapprove')) {
                    const request = this.getView().params as IcStockAdjOutData
                    request.SysDocNo = item.SysDocNo

                    request.Header = Q.tryFirst(IcStockAdjustOutRow.getLookup().items, x=> x.SysDocNo == item.SysDocNo)
                    // IcStockApproveDtRow
                    let fg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
                    let shop = item.SysDocNo.substring(2, 7) 
                    console.log(shop)
                    request.Adjcode =Q.tryFirst(IcStkAdjCodeRow.getLookup().items, x=> x.StkAdjCode == item.StkAdjCode)
                    let s = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x=> x.ShopId == shop)
                    if (fg != null && s != null) { 
                        request.BizName = s.ShopRegName
                        request.BizAddressLine1 = s.ShopRegAddressLine1
                        request.BizAddressLine2 = s.ShopRegAddressLine2
                        request.BizAddressLine3 = s.ShopRegAddressLine3
                        request.TaxId = s.ShopTaxId
                    } else {

                        let q = Q.tryFirst(Administration.CsParaRow.getLookup().items, x=> x.Id == 1)
                        request.BizName = q.BizName
                        request.BizAddressLine1 = q.TaxInvAddrLine1
                        request.BizAddressLine2 = q.TaxInvAddrLine2
                        request.BizAddressLine3 = q.TaxInvAddrLine3
                        request.TaxId = q.BizName
                    }
                   
                    let p = Q.tryFirst(Lookups.VwPsParaRow.getLookup().items, x => x.Id == 1)

                        if(p != null){
                            let vp = window.location.href.replace("#", "")
                            console.log(vp)
                            let ap = vp.replace("/Inventory/IcStockAdjustOut","")
                            request.URLpic = ap + "/upload/" +  p.ShopLogoOnFrontScreen 
                        }else{
                            request.URLpic = "https://" + window.location.host + "/upload/info.jpg"
                        }
                    console.log(request)
                    
                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                    
                    ;
                }
            }
        }
        
    }
}